<section class="new-contract-select-values__container">
  <div class="new-contract-select-values__container-title">
    <h2 class="new-contract-select-values__title">
      {{ 'NEW_CONTRACT_LA.SELECT_VALUES' | i18nextEager | uppercase }}
    </h2>
    <p class="new-contract-select-values__required">* {{ 'NEW_CONTRACT_LA.REQUIRED' | i18nextEager }}</p>
  </div>
  <form [formGroup]="valuesForm" class="new-contract-select-values__form">
    <app-custom-select
      [label]="'NEW_CONTRACT_LA.ACCOUNT'"
      [controlName]="'traddingAccount'"
      [values]="traddingAccountList"
      [defaultValue]="valuesForm.get('traddingAccount').value"
      [searchBar]="true"
      [preload]="true"
      [minLength]="3"
      [required]="true"
      [preload]="true"
      (getData)="getTraddingAccounts($event)"
    ></app-custom-select>
    <app-custom-select
      [label]="'NEW_CONTRACT_LA.BUSINESS'"
      [controlName]="'socialReason'"
      [values]="socialReasonList"
      [defaultValue]="valuesForm.get('socialReason').value"
      [searchBar]="true"
      [preload]="true"
      [minLength]="3"
      [disabled]="valuesForm.get('socialReason').disabled"
      (getData)="getSocialReason($event)"
    ></app-custom-select>
    <app-custom-select
      [label]="'NEW_CONTRACT_LA.INSTALLATION'"
      [controlName]="'installation'"
      [values]="installationList"
      [defaultValue]="valuesForm.get('installation').value"
      [searchBar]="true"
      [preload]="true"
      [minLength]="3"
      [disabled]="valuesForm.get('installation').disabled"
      (getData)="getInstallations(valuesForm.get('installation').value === 'all', $event)"
    ></app-custom-select>
  </form>
</section>
